import React, { useEffect, useState } from 'react';
import {app} from "../api.js";
import { GoogleAuthProvider, getAuth, signInWithPopup, onAuthStateChanged, signOut } from "firebase/auth";
import { getDatabase, ref, update,push,child,get} from "firebase/database";
import Addbook from './Addbook.js';
import '../App.css'
import Admin from './Admin.js';


const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const db = getDatabase(app);
const dbRef = ref(getDatabase(app));



const Login = () => {

  const [AUser, setAUser] = useState(false);

 const [Uid, setUid] = useState({})


  useEffect(() => {

    onAuthStateChanged(auth, user =>{
      if(user){
        console.log(user)
        setUid(user)
        setAUser(true)
      }else{
        setAUser(false)
      }
    });

  },[]);

  function login(){

    signInWithPopup(auth, provider)
    .then((result) => {
      console.log(result);


      onAuthStateChanged(auth, user =>{
        if(user){
          console.log(user.uid)
       

          update(ref(db, 'mountbook/email/'+ user.uid+'/'), {
            email: user.email
          })

          setUid(user)
          setAUser(true)
  
        }else{
          setAUser(false)
  
        }
      });




    }).catch((error) => {
      console.log(error);
    });

  }


  
if (AUser) {
  return (
    <>
   
    {Uid.email==='akhileshbisen25@gmail.com'?<Admin uid={Uid}/>:
    <Addbook uid={Uid}/>
    }
    </>
  )
} else {
  return (
    <div>

     
    <div style={{display:"flex",height:"100vh",justifyContent:"center",alignItems:"center"}}>

      <button onClick={login} class="cssbuttons-io-button">
  Login With Google
  <div class="icon">
    <svg
      height="24"
      width="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0h24v24H0z" fill="none"></path>
      <path
        d="M16.172 11l-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2z"
        fill="currentColor"
      ></path>
    </svg>
  </div>
</button>


    </div>
    </div>
  )
}

}
export default Login
